import * as React from 'react';
import { LProps, withLocalization } from '../../utils/wrappers';
import { compose } from 'redux';
import { asPage } from '../../utils/wrappers/asPage';
import Footer from '../../shared/Footer';
import CompetitionAboutTextSF from './CompetitionAboutTextSF';

const TeamGroup = ({ title, members }: { title: string; members: string[] }) => (
  <div className="cc__about_team__group">
    <div className="cc__about_team__group_title">{title}</div>
    <ul>
      {members.map((name) => (
        <li key={name}>{name}</li>
      ))}
    </ul>
  </div>
);

const AboutSF = ({ t }: LProps<{}>) => (
  <div id="about" className="cc__page__column_content cc__lighttext">
    <div className="cc__page__column_content__left">
      <h1 className="cc__bluetext">{t('About')}</h1>
      <CompetitionAboutTextSF />
      <div className="cc__about_team">
        <div className="cc__about_team__heading">{t('CCSF Challenge Team')}</div>
        <TeamGroup
          title={t('SF Environment Department')}
          members={['Brian Reyes', 'Jax Puliatti', 'Jessica Reyes', 'Sierra Barsten']}
        />
        <TeamGroup
          title={t('Public Works')}
          members={['Jerad Weiner', 'Heidi Rivoire']}
        />
        <TeamGroup
          title={t('Planning')}
          members={['Reanna Tong', 'Veronica Flores']}
        />
        <TeamGroup
          title={t('SFO')}
          members={['Matthew Pucci', 'Tabitha Shikuki', 'Teresa Whinery']}
        />
        <TeamGroup
          title={t('Rec and Park')}
          members={['Taylor Emerson', 'Yael Golan']}
        />
        <div className="cc__about_team__solo">CoolClimate Network (Chris Jones)</div>
      </div>
      <Footer />
    </div>
    <div className="cc__page__column_content__right">
      <div>
        <h2 className="cc__bluetext">{t('What is the CCSF Sustainability Challenge?')}</h2>
        <p>{t('The CCSF Sustainability Challenge is a friendly challenge designed to educate and motivate City staff to take actions focused on circularity, volunteerism, and education that reduce carbon, waste, energy, toxics, water, and cost impacts. Actions cover the 5 Rs (Refuse, Reduce, Reuse, Repair, Recover/Recycle/Compost), Justice, Water, Transportation, Food, Energy, Your Local Economy, Community, and Education.')}</p>
        <p>{t('This challenge is a pilot among participating Departments and Divisions. The Challenge Team will take learned lessons at this scale and prepare for a 2027 agencywide challenge.')}</p>
      </div>
      <div>
        <h2 className="cc__bluetext">{t('How does the Sustainability Challenge work?')}</h2>
        <p>{t('Once you sign up you will learn about your carbon footprint and the actions you can take. Then you can complete pledges — from turning off lights when you leave a room to taking public transit — including actions you may already be doing. Share progress by uploading photos and stories to your personal Challenge page.')}</p>
        <p>{t('For every pledge you take, you earn points. You can track your personal progress and how your Division and Department are doing on the scoreboards.')}</p>
      </div>
      <div>
        <h2 className="cc__bluetext">{t('Who runs the SF Environment Challenge?')}</h2>
        <p>
          {t('The platform was first used across the UC systems. The Cool Campus Challenge is a collaboration between the University of California and the CoolClimate Network at U.C. Berkeley. SF Environment, through its membership with CoolClimate Network, has adapted the platform for the 2026 CCSF Sustainability Challenge and is administering it with technical help from CoolClimate Network.')}
        </p>
      </div>
    </div>
  </div>
);

export default asPage({})(compose(
  withLocalization('about')
)(AboutSF));
